import { useCallback, useEffect, useRef, useState } from 'react';
import Main from '../../components/Main/Main';
import Title from '../../components/Title';
import ProdutoCod from '../../components/autoComplet/ProdutoCod';
import { Card, Typography } from '@material-tailwind/react';
import InputGlobal from '../../components/InputGlobal';
import { useForm } from 'react-hook-form';
import ButtonGlobal from '../../components/ButtonGlobal';
import MsgInputError from '../../components/MsgInputError';
import TdCompras from '../../components/Table/TdCompras';
import { Pencil, Trash2 } from 'lucide-react';
import usePageTitle from '../../hook/usePageTitle';

const TABLE_HEAD = ['Winthor', 'QTD', 'Item', 'Produto', 'Preço', 'Marcas', 'Ações'];

const Compras = () => {
  usePageTitle();
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm();
  const [produto, setProduto] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [formRequired, setFomrRequired] = useState(false);
  const inputRefProduto = useRef(null);

  const [listCompra, setListCompra] = useState([]);

  const editProduct = (winthor) => {
    const produto = listCompra.find((produto) => produto.winthor === winthor);
    setProduto(produto);
    setValue('quantidade', produto.quantidade);
  };

  const deletProduct = (winthor) => {
    setListCompra(listCompra.filter((produto) => produto.winthor !== winthor));
  };

  useEffect(() => {
    setFomrRequired(false);
  }, [produto]);

  const resetInfo = () => {
    setInputValue('');
    setProduto(null);
    reset();
    setValue('quantidade', '');
    clearErrors();
    setFomrRequired(false);
  };

  const onAdd = (data) => {
    if (!produto) {
      setFomrRequired(true);
      return;
    }

    const newproduto = { ...produto, ...data };
    setListCompra((prevLista) => {
      const existe = prevLista.some((item) => item.id === newproduto.id);

      if (existe) {
        return prevLista.map((item) =>
          item.id === newproduto.id ? { ...item, ...newproduto } : item
        );
      } else {
        return [newproduto, ...prevLista];
      }
    });
    resetInfo();
  };

  const textMarcs = useCallback(
    (produto) => {
      const marcas = produto.map((marca) => marca.nome.toUpperCase());
      return marcas ? marcas.join(', ') : '';
    },
    [produto]
  );

  const handleProductFocus = () => {
    inputRefProduto.current?.focus();
  };

  const handleEnterPress = (event) => {
    // Adicionar produto quando clicado enter no ultimo campo do formulario
    if (event.key === 'Enter') {
      handleSubmit(onAdd)();
      handleProductFocus();
    }
  };

  return (
    <Main>
      <Title>Solicitação Compra</Title>
      <div
        className="items-center flex 
      flex-col  flex-1 overflow-auto"
      >
        <div className="w-[90%] mx-auto md:flex md:w-full gap-x-5 justify-center ">
          <div className="md:w-[50%]  ">
            <Typography
              color="white"
              variant="h6"
              className="mb-1 text-left font-medium text-black dark:text-white capitalize"
            >
              Produto
            </Typography>
            <ProdutoCod
              register={register}
              value={produto}
              setValue={setProduto}
              inputValue={inputValue}
              setInputValue={setInputValue}
              inputRef={inputRefProduto}
            />
            {formRequired && <MsgInputError text="Este campo é obrigatório" />}
          </div>
          <div onKeyDown={handleEnterPress}>
            <InputGlobal
              type="number"
              label="Quantidade"
              placeholder="QTD"
              register={register}
              formCamp={'quantidade'}
              errors={errors?.quantidade ? errors : false}
              validations={{ required: true }}
              required={true}
            />
          </div>
          <div>
            <Typography className="text-transparent" variant="h6">
              ''
            </Typography>
            <ButtonGlobal text="Adicionar" click={handleSubmit(onAdd)} type="submit" />
          </div>
        </div>
        <div className="mt-5 w-[90%] mx-auto overflow-auto">
          <Card className="w-full bg-transparent global-scrollbar">
            <table className="min-w-max table-auto text-left mx-auto  ">
              <thead className="sticky top-0 ">
                <tr>
                  {TABLE_HEAD.map((head) => (
                    <th key={head} className="p-2 bg-lightTh dark:bg-darkTh">
                      <Typography color="white" className="font-bold">
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-lightColorBg dark:bg-darkTdRow">
                {listCompra.map((produto) => (
                  <tr
                    key={produto.id}
                    className="uppercase text-black font-fold even:bg-white dark:even:bg-darkRbgEstq"
                  >
                    <TdCompras cssTd="w-20">{produto.winthor}</TdCompras>
                    <TdCompras cssTd="w-10">{produto.quantidade}</TdCompras>
                    <TdCompras cssTd="w-10">{produto.unidadeMedida}</TdCompras>
                    <TdCompras>{produto.nome.toUpperCase()}</TdCompras>
                    <TdCompras cssTd="w-7">
                      {produto.lastPreco === '0,00' ? '' : produto.lastPreco}
                    </TdCompras>
                    <TdCompras cssTd="">{textMarcs(produto.marcaDeCompra)}</TdCompras>
                    <TdCompras cssTd="w-10">
                      <div className="flex gap-2">
                        <Pencil
                          className="cursor-pointer"
                          onClick={() => editProduct(produto.winthor)}
                        />
                        <Trash2
                          className="cursor-pointer"
                          color="red"
                          onClick={() => deletProduct(produto.winthor)}
                        />
                      </div>
                    </TdCompras>
                  </tr>
                ))}
                {listCompra.length === 0 && (
                  <tr>
                    <td colSpan={TABLE_HEAD.length}>
                      <Typography color="black" className="font-bold pl-5" variant="h6">
                        Adicione produtos
                      </Typography>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Card>
        </div>
      </div>
    </Main>
  );
};

export default Compras;
